export const REPORT_SOURCES = [
  {
    value: 'combined',
    label: 'App & Stores sales',
  },
  {
    value: 'app',
    label: 'App sales only',
  },
  {
    value: 'stores',
    label: 'Stores sales only',
  },
];

export const REPORT_CUSTOMER_TYPES = [
  {
    value: 'new',
    label: 'New customers',
  },
  {
    value: 'existing',
    label: 'Existing customers',
  },
  {
    value: 'all',
    label: 'All customers',
  },
];

export const CUSTOMER_TYPES = {
  NEW: 'new',
  EXISTING: 'existing',
  ALL: 'all',
} as const;

export type CustomerType = (typeof CUSTOMER_TYPES)[keyof typeof CUSTOMER_TYPES];

export const SOURCES = {
  COMBINED: 'combined',
  APP: 'app',
  STORES: 'stores',
} as const;

export type Source = (typeof SOURCES)[keyof typeof SOURCES];

export const FUNCTION_NAMES = {
  SUMMARY: 'appAndSquareOrdReports-orderSummary1',
  CUSTOMER_TRENDS: 'oldVsNewCustLocWise-getMonthWiseUniqueCustomers',
  ITEM_SUMMARY: 'appAndSquareItemReports-allItemsSummary',
  CATEGORY_SUMMARY: 'categWiseReportBQ-appOrdersSubCategReport',
  STORES_SUMMARY: 'appAndSquareOrdReports-orderYoYReport',
  PROMOTIONS_SUMMARY: 'appPromotionsReportBQ-eventsSummary',
  PROMOTIONS: 'appPromotionsReportBQ-eventsSummaryAndTrends',
  REPEAT_RATES: 'repeatedCustomersReports-avgOrderAndSales',
  TRAFFIC_SUMMARY: 'customerReports-totalAndCampaignSignedUpCustomers',
  DAU_WAU_MAU_QAU: 'customerReports-getDauWauMauQauData',
  AVG_MONTHLY_FREQUENCY: 'customerReports-getAvgMonthlyFrequency',
  REPEAT_CUSTOMERS_WITHIN_X_DAYS: 'customerReports-repeatCustomersWithinXDaysOfFirstOrder',
  COHORT_REPORT: 'customerReports-getCohortCountAndPercentages',
  AVERAGE_LTV: 'customerReports-getAverageLTV',
  PROMO_SIGNUP_STATS: 'appPromotionsReportBQ-promoSignUpUserStats',
  PROMO_SIGNUP_EXPORT: 'appPromotionsReportBQ-promoSignUpUserExport',
};

export const FRANCHISEES = {
  ALEENA: 'ALEENA',
  ELI_NAIM: 'ELI_NAIM',
  BERESHEET: 'BERESHEET',
  JONATHAN: 'JONATHAN',
  SINGULAR: 'SINGULAR',
  MATTO: 'MATTO',
};

export const CLUSTERS = {
  [FRANCHISEES.ALEENA]: [
    'LAQQZK9WWJHGT',
    'LR6V6S49J67AF',
    'RQAHVJ34GZZZZ',
    'LKJ4RKBJC0XT7',
    'L8CPSF8WD337Y',
  ],
  [FRANCHISEES.ELI_NAIM]: [
    'LPZHCMYQDKHHF',
    'LG4ZDN8YVC7ZC',
    'WTG0MSEY3ZF84',
    '9EEG341ZY027T',
    'L274XTNSHGTSK',
  ],
  [FRANCHISEES.BERESHEET]: [
    'LXNN7PTTDKBC0',
    '1JM1BXBYVE3QH',
    '9M08MVHZP82PS',
    'N6WGMKAZ7GMXC',
    'L07PMA0D6HBQ9',
    'LX0VNYD1EJR82',
  ],
  [FRANCHISEES.JONATHAN]: ['9J50QV0QZM8ZQ', 'L59SSK9Z1PN8A', 'L60EJR4M8N45S'],
  [FRANCHISEES.MATTO]: ['L36PJ6BV9XZY7', '7D3ZMPMPHA7PW', 'BMZDQJ513PE5J', '904WQE0JCSMCB'],
};
